export default __webpack_public_path__ + "static/media/tiktok.45c6baa7.svg";